import { ListItemIcon, ListItemText } from '@/components/Dropdown/MenuItems/components';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import theme from '@/theme';
import MenuItem from '@mui/material/MenuItem';

interface Props {
    onClick: () => void;
    src: string;
    text: string;
    disabled?: boolean;
}

export const MenuItemIcon = ({ onClick, src, text, disabled = false }: Props) => {
    return (
        <MenuItem disabled={disabled} onClick={onClick}>
            <ListItemIcon>
                <MaskedIcon src={src} color={theme.colors.secondary.main} size="18px" />
            </ListItemIcon>
            <ListItemText>{text}</ListItemText>
        </MenuItem>
    );
};
